import { render, staticRenderFns } from "./OverviewDetails.vue?vue&type=template&id=38acb6bc"
import script from "./OverviewDetails.vue?vue&type=script&lang=js"
export * from "./OverviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports